const SvgOrderArrowList = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M32 11.333H16a.667.667 0 0 0-.667.667v17.057l-6.862-6.862-.943.943 8 8c.26.26.683.26.943 0l8-8-.943-.943-6.862 6.862V12.666h15.333v-1.333z" />
  </svg>;
export default SvgOrderArrowList;